export default "__VITE_ASSET__13c961cd__"